export default __webpack_public_path__ + "static/media/1939.3bfe9bbd.png";